<template>
	<div class="special-service" v-if="specialService">
		<BaseCmsLabel code="selected_assembly" />: <strong v-if="specialService.title">{{specialService.title}}</strong>
	</div>	
</template>

<script setup>
	const props = defineProps(['data']);

	const specialService = computed(() => {
		if(props.data?.item?.offer_attributes) {
			const serviceKey = Object.keys(props.data.item.offer_attributes)[0];
			const service = props.data.item.offer_attributes[serviceKey];
			if(service && ['brez-montaze', 'z-montazo'].includes(service.slug)) return service;
		}
		return null;
	});
</script>

<style lang="less" scoped>
	.special-service{
		border: 1px solid var(--gray2); border-radius: 8px; padding: 14px 20px 14px 15px; font-size: clamp(14px, 1.5vw, 15px); position: relative;
	}
</style>